export default __webpack_public_path__ + "static/grace2-70754ed648991e7ecc50fedd9a0665ad.jpg";